import { useEffect, useState } from 'react'

import http from './http'

/**
 * Lädt Bilder, die nur angemeldet abrufbar sind.
 *
 * Ein <img src="..."> schickt keinen Anmelde-Kopfeintrag mit. Screenshots
 * liegen aber bewusst hinter der angemeldeten Schnittstelle, weil auf ihnen
 * echte Namen und Firmendaten zu sehen sind. Also holen wir sie selbst und
 * geben dem Bild eine lokale Adresse auf die geladenen Daten.
 *
 * Diese Adressen müssen wieder freigegeben werden. Ohne das sammelt der
 * Browser bei jedem Öffnen eines Tickets weitere Bilder im Speicher an, die
 * er nie mehr loswird — bei längerer Arbeit in der Liste wird das spürbar.
 *
 * @param {Array<{id: number, url: string}>} sources
 * @returns {Object} id → lokale Adresse; fehlt ein Eintrag, lädt er noch
 */
export default function useAuthImages(sources) {
	const [urls, setUrls] = useState({})

	// Über die Kennungen und Adressen vergleichen, nicht über das Feld selbst:
	// Der Aufrufer baut die Liste bei jedem Rendern neu, die Werte darin sind
	// aber gleich. Ohne das liefe der Effekt endlos.
	const key = sources.map(source => `${source.id}:${source.url}`).join('|')

	useEffect(() => {
		let cancelled = false
		const created = []

		Promise.all(
			sources.map(source =>
				http
					.get(source.url, { responseType: 'blob', disableToast: true })
					.then(({ data }) => {
						const objectUrl = URL.createObjectURL(data)
						created.push(objectUrl)
						return [source.id, objectUrl]
					})
					// Ein einzelnes fehlendes Bild darf die anderen nicht mitreißen.
					.catch(() => null)
			)
		).then(pairs => {
			if (cancelled) {
				created.forEach(URL.revokeObjectURL)
				return
			}
			setUrls(Object.fromEntries(pairs.filter(Boolean)))
		})

		return () => {
			cancelled = true
			created.forEach(URL.revokeObjectURL)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [key])

	return urls
}
